import cn from 'classnames';
import { CheckBox } from 'components/UtilElements';
import * as dt from 'core/datetime';
import { DATE_FORMAT } from 'globals/constants';

import { getColorClassForPercentage } from './helpers';

export interface PollScoresProps {
  polls: BulkActivityScore[];
  selectedPollIds: string[];
  toggleSelectedPollId: (pollId: string) => void;
}

const PollScores = ({ polls, selectedPollIds, toggleSelectedPollId }: PollScoresProps) => {
  return (
    <table className='table table--bordered activity__bulk-export-score-table'>
      <tbody>
        {polls.map((poll) => {
          const isSelected = selectedPollIds.includes(poll.activityId);
          return (
            <tr
              key={poll.activityId}
              className={cn('gutters', 'clickable', { selected: isSelected })}
              onClick={() => toggleSelectedPollId(poll.activityId)}
            >
              <td>
                <CheckBox isChecked={isSelected} readonly />
              </td>
              <td>
                <div className='table__cell'>
                  <div className='table__cell-header table__cell-header--title'>{`Poll ${poll.activityNum}`}</div>
                  <div className='table__cell-value table__cell-value--sm'>{poll.title}</div>
                </div>
              </td>
              <td>
                <div className='table__cell'>
                  <div
                    className={cn('tag', {
                      'tag--green': poll.toBeDone === 'inClass',
                      'tag--blue': poll.toBeDone === 'preClass',
                    })}
                  >
                    {poll.toBeDone === 'inClass' ? 'IN CLASS' : 'PRE CLASS'}
                  </div>
                  <div className='table__cell-value table__cell-value--no-wrap'>
                    {dt.format(poll.dueDateTime, DATE_FORMAT)}
                  </div>
                </div>
              </td>
              <td>
                <div className='table__cell'>
                  <div className='table__cell-header'>SUBMISSIONS</div>
                  <div className='table__cell-value'>{poll.numSubmissions}</div>
                </div>
              </td>
              <td>
                <div className='table__cell'>
                  <div className='table__cell-header'>PARTICIPATION</div>
                  <div>
                    {poll.hasScore ? (
                      <span className={getColorClassForPercentage(poll.avgScore)}>{poll.avgScore}%</span>
                    ) : (
                      '--'
                    )}
                  </div>
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default PollScores;
